import { Injectable } from '@angular/core';
import { AssetTeam, Function, Project, ProjectStatus, ProjectType } from '@app/shared/models';
import { ProjectsView } from '@app/shared/models/projects-view';

@Injectable({ providedIn: 'root' })
export class ProjectsViewService {

  public convertToProject(model: ProjectsView): Project {
    if (typeof model.ProjectStatus != "string") {
      return model as any;
    }

    let project = new Project();

    project.ProjectId = model.ProjectId;
    project.AfeNumber = model.AfeNumber;
    project.Name = model.Name;
    project.ProjectDescription = model.ProjectDescription;
    project.DefaultProjectTeamId = model.DefaultProjectTeamId;
    project.ProjectTypeId = model.ProjectTypeId;
    project.ProjectStatusId = model.ProjectStatusId;
    project.AssetTeamId = model.AssetTeamId;
    project.DivisionId = model.DivisionId;
    project.IsProjectTeamSync = model.IsProjectTeamSync;
    project.FunctionId = model.FunctionId;
    project.ProjectSubTypeId = model.ProjectSubTypeId;
    project.ScenarioId = model.ScenarioId;
    project.CreatedBy = model.CreatedBy;

    if (model.ProjectTypeId != null) {
      project.ProjectType = new ProjectType();
      project.ProjectType.ProjectTypeId = model.ProjectTypeId;
      project.ProjectType.Description = model.ProjectType;
    }

    if (model.ProjectStatusId != null) {
      project.ProjectStatus = new ProjectStatus();
      project.ProjectStatus.ProjectStatusId = model.ProjectStatusId;
      project.ProjectStatus.Description = model.ProjectStatus;
    }

    if (model.AssetTeamId != null) {
      project.AssetTeam = new AssetTeam();
      project.AssetTeam.AssetTeamId = model.AssetTeamId;
      project.AssetTeam.AssetTeamCode = model.AssetTeamCode;
    }

    if (model.FunctionId != null) {
      project.Function = new Function();
      project.Function.FunctionId = model.FunctionId;
      project.Function.Description = model.Function;
    }

    return project;
  }
}